import { urlBaseApi as apiUrl } from '../consts';

const endpointUrl = apiUrl + '/options/public';

export const getOption = optionName => {
  return {
    url: `${endpointUrl}/${optionName}`,
    method: 'GET'
  };
};

export const updateOption = (token, optionName, optionValue) => {
  return {
    url: `${endpointUrl}`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    data: {
      optionName: optionName,
      optionValue: optionValue
    }
  };
};

export const updateHeroImage = (token, body) => {
  return {
    url: apiUrl + `/bannerImages/`,
    method: 'PUT',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const updateHeroImagesScroller = (token, body) => {
  return {
    url: apiUrl + `/image-scrollers/upsert`,
    method: 'POST',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};
export const getHeroImagesScroller = (token, body) => {
  return {
    url: apiUrl + `/image-scrollers/get-all`,
    method: 'get',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};
export const getHeroImagesScrollerById = (token, body,id) => {
  return {
    url: apiUrl + `/image-scrollers/get/${id}`,
    method: 'get',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

// export const updateAdminMessage = (token, body) => {
//   return {
//     url: apiUrl + `/options/landing-image`,
//     method: 'POST',
//     data: body,
//     headers: {
//       Authorization: 'Bearer ' + token
//     }
//   };
// };

export const updateContactUs = (token, body) => {
  return {
    url: apiUrl + `/contact`,
    method: 'PUT',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const getImage = (token) => {
  return {
    url: `${apiUrl}/bannerImages/`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
}
export const GetContact = (token) => {
  return {
    url: apiUrl + `/contact`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};